export default (apiFetch) => async (props) => {
  const response = await apiFetch({
    endpoint: "contact-us",
    method: "post",
    okStatus: 200,
    body: { ...props },
  });

  return await response.json();
};
